import React from 'react'
import { TNAppDownloadSectionBottom } from '../TNAppDownloadSectionBottom/TNAppDownloadSectionBottom'
import { TNAppDownloadSectionMiddle } from '../TNAppDownloadSectionMiddle/TNAppDownloadSectionMiddle'
import { TNAppDownloadSectionTop } from '../TNAppDownloadSectionTop/TNAppDownloadSectionTop'

export function TNAppDownloadPage() {
    return (
        <>
            <TNAppDownloadSectionTop />
            <TNAppDownloadSectionMiddle />
            <TNAppDownloadSectionBottom />
        </>
    )
}
